import type { MethodStep } from './schema'

/** The Brewed Method: the three jobs every follow-up system has to do, in order. */
export const method = {
  eyebrow: 'The Brewed Method',
  title: 'Catch. Brew. Pour.',
  summary: 'The three jobs every follow-up system has to do, in this order.',
  steps: [
    { name: 'Catch', body: 'Every lead gets saved. No one slips through.', inputs: ['Forms', 'DMs', 'Ads', 'Referrals'] },
    { name: 'Brew', body: 'The system follows up for you, for as long as it takes.', inputs: ['Tags', 'Emails', 'Texts'] },
    { name: 'Pour', body: 'Ready-to-buy people land in your calendar. You just show up.', inputs: ['Calendar', 'Inbox', 'CRM'] },
  ] satisfies MethodStep[],
}
